import { render, staticRenderFns } from "./OrganizationSponsorTab.vue?vue&type=template&id=78544848&scoped=true&"
import script from "./OrganizationSponsorTab.vue?vue&type=script&lang=js&"
export * from "./OrganizationSponsorTab.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSponsorTab.vue?vue&type=style&index=0&id=78544848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78544848",
  null
  
)

export default component.exports